// extracted by mini-css-extract-plugin
module.exports = {"cardRoot":"createSearch_cardRoot__14FJL","cancel":"createSearch_cancel__3LbV9"};